module.exports = __webpack_public_path__ + "img/white-security.8dfdebf4.png";